import { render, staticRenderFns } from "./PresentationComment.vue?vue&type=template&id=3b37cd04"
import script from "./PresentationComment.vue?vue&type=script&lang=ts"
export * from "./PresentationComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports